import { Typography } from "@mui/material";
import { EnterPartitionDetails } from "domains/partitions/components/enter-partition-details";

import localisations from "../../../localisation";

function EnterDetailsStage(props: any) {
    const { heading, blurb } = localisations.createPartition.stages.enterDetails;
    const { fields, handleFieldChange } = props;

    return (
        <>
            <Typography variant="h5" gutterBottom>
                {heading}
            </Typography>

            <Typography variant="body1" gutterBottom>
                {blurb}
            </Typography>

            <EnterPartitionDetails details={fields} onChange={handleFieldChange} />
        </>
    );
}

export default EnterDetailsStage;
